import React from "react";
import { BrowserRouter, Route, Routes, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { initMatomo, trackSpaNavigation } from "./lib/matomo";
import { createRoot } from "react-dom/client";
import myAppConfig from "./config";

// import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import 'bootstrap-icons/font/bootstrap-icons.css';

import { RouterPath } from "./assets/dictionary/RouterPath";
import { PrivateRoute } from "./components/auth/PrivateRoute";
import { AdminRoute } from "./components/auth/AdminRoute";
import { configureAxiosInterceptors } from "./lib/axiosInterceptors";

import App from "./App";
import AuthCombined from "./pages/auth/AuthCombined";
import AuthEntryRedirect from "./components/auth/AuthEntryRedirect";
import ConfirmationEmailSent from "./pages/sign_up/confirmation_email_sent/ConfirmationEmailSentModern";
import ForgotPasswordForm from "./pages/forgot_password/forgot_password_form/ForgotPasswordFormModern";
import ForgotPasswordEmailSent from "./pages/forgot_password/forgot_password_email_sent/ForgotPasswordEmailSent";
import ResetPasswordForm from "./pages/forgot_password/reset_password/ResetPassword";
import PasswordChanged from "./pages/forgot_password/password_changed/PasswordChanged";
import LinkNotValid from "./pages/link_not_valid/LinkNotValid";
import ConfirmEmail from "./pages/sign_up/confirm_email/ConfirmEmail";
import Chat from "./pages/chat/ChatModern";
import Copilot from "./pages/copilot/CopilotModern";
import PageAide from "./pages/page_aide/PageAide";
import Billing from "./pages/billing/BillingModern";
import BillingSuccess from "./pages/billing/BillingSuccess";
import BillingCancel from "./pages/billing/BillingCancel";
import AdminRefreshTokensPage from "./pages/admin/AdminRefreshTokensPage";
import ProfilePage from "./pages/profile/ProfilePage";
import Notification from "./pages/notification/Notification";


const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
configureAxiosInterceptors();

function MatomoInit() {
  useEffect(() => {
    const siteId = myAppConfig?.analytics?.MATOMO_SITE_ID || process.env.REACT_APP_MATOMO_SITE_ID || "1";
    const basePath = myAppConfig?.analytics?.MATOMO_BASE_PATH || process.env.REACT_APP_MATOMO_BASE_PATH || "/matomo/";
    initMatomo(siteId, basePath);
  }, []);
  return null;
}

function MatomoRouteTracker() {
  const location = useLocation();
  useEffect(() => {
    trackSpaNavigation(location.pathname + location.search + location.hash);
  }, [location]);
  return null;
}

root.render(
  <BrowserRouter>
    <MatomoInit />
    <MatomoRouteTracker />
      <Routes>
      <Route path={RouterPath.HOME} element={<App />}>
        <Route
          index
          element={<Navigate to={RouterPath.CHAT} replace />}
        />
        <Route path={RouterPath.AUTH} element={<AuthCombined />} />
        <Route path={RouterPath.LOGIN} element={<AuthEntryRedirect tab="login" />} />
        <Route path={RouterPath.SIGNUP} element={<AuthEntryRedirect tab="signup" />} />
        <Route
          path={RouterPath.SIGNUP_MAIL_SENT}
          element={<ConfirmationEmailSent />}
        />
        <Route
          path={RouterPath.SIGNUP_CONFIRM_EMAIL}
          element={<ConfirmEmail />}
        />
        <Route
          path={RouterPath.FORGOT_PASSWORD}
          element={<ForgotPasswordForm />}
        />
        <Route
          path={RouterPath.FORGOT_PASSWORD_MAIL_SENT}
          element={<ForgotPasswordEmailSent />}
        />
        <Route
          path={RouterPath.RESET_PASSWORD}
          element={<ResetPasswordForm />}
        />
        <Route
          path={RouterPath.PASSWORD_CHANGED}
          element={<PasswordChanged />}
        />
        <Route path={RouterPath.LINK_NOT_VALID} element={<LinkNotValid />} />

        <Route
          path={RouterPath.CHAT}
          element={
            <PrivateRoute>
              <Chat />
            </PrivateRoute>
          }
        />
        <Route
          path={RouterPath.CHAT_DETAIL}
          element={
            <PrivateRoute>
              <Chat />
            </PrivateRoute>
          }
        />

        <Route
          path={RouterPath.COPILOT}
          element={
            <PrivateRoute>
              <Copilot />
            </PrivateRoute>
          }
        />
        <Route
          path={RouterPath.COPILOT_DETAIL}
          element={
            <PrivateRoute>
              <Copilot />
            </PrivateRoute>
          }
        />

        <Route
          path={RouterPath.AIDE_PAGE}
          element={
            <PrivateRoute>
              <PageAide />
            </PrivateRoute>
          }
        />

        <Route
          path={RouterPath.BILLING}
          element={
            <PrivateRoute>
              <Billing />
            </PrivateRoute>
          }
        />

        <Route
          path={RouterPath.BILLING_SUCCESS}
          element={
            <PrivateRoute>
              <BillingSuccess />
            </PrivateRoute>
          }
        />

        <Route
          path={RouterPath.BILLING_CANCEL}
          element={
            <PrivateRoute>
              <BillingCancel />
            </PrivateRoute>
          }
        />

        <Route
          path={RouterPath.ADMIN_REFRESH_TOKENS}
          element={
            <AdminRoute>
              <AdminRefreshTokensPage />
            </AdminRoute>
          }
        />

        <Route
          path={RouterPath.PROFILE}
          element={
            <PrivateRoute>
              <ProfilePage />
            </PrivateRoute>
          }
        />
        <Route path={RouterPath.NOTIFICATION} element={
          <PrivateRoute>
            <Notification />
          </PrivateRoute>
        } />

        <Route path="*" element={<LinkNotValid />} />
      </Route>
      </Routes>
  </BrowserRouter>
);

